import { Button, Grid, InputAdornment, TextField } from "@mui/material";
import React, { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { AlertDialog } from "../common/AlertDailog";
import DragAndDropUpload from "./UploadCompStatic";
import SampleListDatagrid from "./SampleListDataGrid";

const AddEAModalForm: React.FC = () => {
  const [openUploadProtocol, setOpenUploadProtocol] = useState(false);
  const handleCloseUploadProtocol = () => {
    setOpenUploadProtocol(false);
  };

  const [openAddSample, setOpenAddSample] = useState(false);
  const handleCloseAddSample = () => {
    setOpenAddSample(false);
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item md={12}>
          <TextField
            id="textfield_id"
            fullWidth
            label="Test Name"
            variant="standard"
          />
        </Grid>
        <Grid item md={12}>
          <TextField
            id="textfield_id"
            fullWidth
            label="Study Name"
            variant="standard"
          />
        </Grid>
        <Grid item md={12}>
          <Grid container columnSpacing={3} alignItems="flex-end">
            <Grid item xs>
              <TextField
                id="sample"
                fullWidth
                label="Sample"
                variant="standard"
              />
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={() => {
                  setOpenAddSample(true);
                }}
              >
                Sample
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid item md={12}>
          <TextField
            id="input-with-icon-textfield"
            fullWidth
            label="Expected Date"
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  <CalendarTodayIcon color="primary" />
                </InputAdornment>
              ),
            }}
            variant="standard"
          />
        </Grid>
        <Grid item md={12}>
          <Grid container columnSpacing={3} alignItems="flex-end">
            <Grid item xs>
              <TextField
                id="sample"
                fullWidth
                label="Testing Protocol"
                variant="standard"
              />
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={() => {
                  setOpenUploadProtocol(true);
                }}
              >
                Upload
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid item md={12}>
          <TextField
            id="requestedby_id"
            fullWidth
            label="Requested by"
            variant="standard"
          />
        </Grid>
        <Grid item md={12}>
          <TextField
            id="note_id"
            fullWidth
            multiline
            label="Note"
            variant="standard"
            minRows={4}
            maxRows={6}
          />
        </Grid>
      </Grid>
      <AlertDialog
        open={openUploadProtocol}
        title="Upload Testing Protocol"
        handleClose={handleCloseUploadProtocol}
        maxWidth="sm"
      >
        <DragAndDropUpload />
      </AlertDialog>
      <AlertDialog
        open={openAddSample}
        title="⟵ Add Samples"
        handleClose={handleCloseAddSample}
        maxWidth="md"
        confirmBtn="Add"
        cancelBtn="Cancel"
      >
        <SampleListDatagrid />
      </AlertDialog>
    </>
  );
};

export default AddEAModalForm;
